import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    estaLogado: false,
    defautRedesSociais: null,
  },
  getters: {
  },
  mutations: {

  },
  actions: {
  },
  modules: {
  },
  // plugins: [createPersistedState()]
})
